import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import msalConfig from "./services/msalConfg";
import React from "react";
import ReactDOM from "react-dom/client";
import ThemedApp from "./ThemedApp";
import { ThemeModeProvider} from "./theme/colorThemeContext";
import { BrowserRouter } from "react-router-dom";
import { loadRuntimeConfig, getRuntimeConfig } from "./config/runtimeConfig";
import { initApi } from "./services/api";
import { clearAuthRedirectInProgress } from "./Utils/common";
import "./index.css";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

const msalInstance = new PublicClientApplication(msalConfig);

const isSSOLogin = localStorage.getItem("ssoLogin") === "true";

function renderApp() {
  const config = getRuntimeConfig();

  // Initialize Axios/API base URL from runtime config.json
  initApi(config.API_URL);

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <ThemeModeProvider>
            <ThemedApp />
          </ThemeModeProvider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

async function initializeMsalAndRender() {
  try {
    const response = await msalInstance.handleRedirectPromise();

    if (response) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const currentAccounts = msalInstance.getAllAccounts();

      if (currentAccounts.length > 0) {
        msalInstance.setActiveAccount(currentAccounts[0]);
      }
    }
  } catch (error) {
    console.error("Redirect error:", error);
  } finally {
    localStorage.removeItem("ssoLogin");
    clearAuthRedirectInProgress();
    renderApp();
  }
}

async function startApp() {
  try {
    await loadRuntimeConfig();

    if (isSSOLogin) {
      await initializeMsalAndRender();
    } else {
      renderApp();
    }
  } catch (error) {
    console.error(
      "Unable to start app because runtime config failed to load",
      error
    );

    rootElement.innerHTML = "Unable to load application configuration.";
  }
}

startApp();
